<template>
  <ion-page class="ion-page intro_page_main">
    <ion-toolbar>
      <!-- <ion-buttons slot="start">
        <ion-button class="button_back" v-if="activeIndex" @click="sliderBack">
          <ion-icon name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons> -->
      <!-- <ion-buttons slot="end">
        <ion-button class="pill next-pill-button" @click="skipIntro">
          <span v-if="activeIndex == pageText[userRole].length - 1">Next</span>
          <span v-else>Skip</span>
        </ion-button>
      </ion-buttons> -->
    </ion-toolbar>

    <ion-content fullscreen scroll-y="false">
      <div class="slider-back" @click="sliderBack()" v-if="showBackArrow">
        <ion-icon name="arrow-back" title=""></ion-icon>
      </div>
      <div class="slider-next" @click="sliderNext()" v-if="showNextArrow">
        <ion-icon name="arrow-forward"></ion-icon>
      </div>
      <ion-slides
        pager="true"
        :options="slideOpts"
        ref="slider"
        @ionSlideDidChange="slideChange"
        @ionSlideDrag="slideDrag"
      >
        <ion-slide
          class="ion-padding"
          v-for="(slide, index) in pageText[userRole]"
          :key="slide.title"
        >
          <h2 class="title">{{ slide.title }}</h2>
          <span class="description">
            {{ slide.description }}
          </span>
          <ion-toolbar>
            <ion-title>
              <button class="skip-button" @click="skipIntro">
                <span v-if="activeIndex == pageText[userRole].length - 1">NEXT</span>
                <span v-else>SKIP</span>
              </button>
            </ion-title>
          </ion-toolbar>
          <div class="slide_image" v-if="isAustralia">
            <img
              :src="
                require(`@/assets/img/intro/${userRole}/image${index + 1}.png`)
              "
              alt=""
            />
          </div>
          <div class="slide_image" v-else>
            <img
              :src="
                require(`@/assets/img/intro/us/${userRole}/image${index + 1}.png`)
              "
              alt=""
            />
          </div>
          <div class="slide_background">
            <div
              :style="
                `background-image: url('${require('@/assets/img/intro/background/back.svg')}'); width: ${
                  pageText[userRole].length
                }00%; left: -${index * 100}%;`
              "
              class="slide_background_img"
            ></div>
          </div>
        </ion-slide>
      </ion-slides>
    </ion-content>
  </ion-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {
  IonPage,
  IonContent,
  // IonButton,
  // IonBackButton,
  // IonButtons,
  IonIcon,
  IonToolbar,
  IonSlides,
  IonSlide,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
  useRouter,
} from "vue-router";

export default {
  components: {
    IonPage,
    IonContent,
    IonIcon,
    IonToolbar,
    IonSlides,
    IonSlide,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const isAustralia = isAustraliaRegion();
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const showBackArrow = ref(false);
    const showNextArrow = ref(true);

    const pageText = {
      pharmacy: [
        {
          title: "Create Vacancy",
          description:
            "Create a role vacancy and look for a pharmacy professional to fill in the shifts",
        },
        {
          title: "Minimal effort",
          description:
            "Enter shift details and leave the rest to us, it’s that simple",
        },
        {
          title: "Easy shift tracking",
          description:
            "Stay alert to upcoming shifts using our integrated calendar",
        },
        {
          title: "Message",
          description:
            "Discuss role details",
        },
      ],
      locum: [
        {
          title: "Be prioritised",
          description:
            "Based on location and preferences, strongest match picks first!",
        },
        {
          title: "Immediate confirmation",
          description:
            "Shifts are confirmed instantly, so you don’t need to wait for approval",
        },
        {
          title: "Shift Calendar",
          description: "Track your upcoming shifts and your job history",
        },
        {
          title: "Message",
          description:
            "Discuss role details",
        },
      ],
    };

    const slider = ref(null);
    const activeIndex = ref(0);

    const slideChange = (e) => {
      e.target.getActiveIndex().then((i) => {
        activeIndex.value = i;
      });
      e.target.isBeginning().then((i) => {
        e.target.lockSwipeToPrev(i);
        showBackArrow.value = !i;
      });
      e.target.isEnd().then((i) => {
        e.target.lockSwipeToNext(i);
        showNextArrow.value = !i;
      });
    };
    const slideDrag = (e) => {
      e.target.isBeginning().then((i) => {
        e.target.lockSwipeToPrev(i);
        showBackArrow.value = !i;
      });
      e.target.isEnd().then((i) => {
        e.target.lockSwipeToNext(i);
        showNextArrow.value = !i;
      });
    };
    const skipIntro = () => {
      $store.dispatch("SAVE_USER_DATA", {
        intro: 1,
        hideLoading: true,
      });
      $router.push({
        name: "home",
      });
    };

    onMounted(() => {
      slider.value.$el.lockSwipeToPrev(true);
    });
    const slideOpts = {
      initialSlide: activeIndex.value,
      speed: 400,
    };
    const sliderBack = () => {
      activeIndex.value = activeIndex.value - 1;
      slider.value.$el.slideTo(activeIndex.value, 400);
    };
    const sliderNext = () => {
      activeIndex.value = activeIndex.value + 1;
      slider.value.$el.slideTo(activeIndex.value, 400);
    };
    return {
      slider,
      activeIndex,
      userRole,
      pageText,
      slideChange,
      slideDrag,
      skipIntro,
      slideOpts,
      sliderBack,
      isAustralia,
      sliderNext,
      showBackArrow,
      showNextArrow,
    };
  },
};
</script>